import { Currency } from '@/core/currency/interfaces';

const AUD: Currency = {
    name: 'Australian Dollar',
    demonym: 'Australian',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '036',
    symbol: 'AU$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'AUD',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default AUD;
